import { createInteractionBarComponent } from '@vfde-brix/interaction-bar';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountInteractionBar = () => {
    const elements = document.getElementsByClassName('brix-interaction-bar');

    for (let i = 0, x = elements.length; i < x; i += 1) {

        createInteractionBarComponent(elements[i], NO_PATTERN_BUSINESS_LOGIC);
    }
}
